import { Dispatch } from "redux"
import { MtProject } from "server/models"
import { deepCopy } from "client/utils"
import {
    ProjectSettings,
    LoadAccountSettings,
    LoadProjectSettings,

    CopyDefaultCcApprovalLevels,
    CopyDefaultCcResponses,
    CopyDefaultCcReviewReviewTypes,

    CopyDefaultCcRequirementPriorities,
    CopyDefaultCcRequirementReviewMethods,
    CopyDefaultCcRequirementSmartCompliances,
    CopyDefaultCcRequirementStatuses,
    CopyDefaultCcRequirementTypes,

    SaveProjectSettings,
    setProjectProjectSettings,
} from "client/store"

const ImportDefaultProjectSettings = (project: MtProject, dispatch?: Dispatch) => (
    LoadAccountSettings(project.accountId)
    .then((accountSettings) => (
        LoadProjectSettings(project.id)
        .then((settings) => {
            const newSettings: ProjectSettings = deepCopy(settings)

            // copy study fields from account
            if (!newSettings.study.studyFieldsAssigned) {
                newSettings.study.studyFields = accountSettings.study.studyFields
                newSettings.study.studyFieldsAssigned = true
            }
            if (!newSettings.study.teamMembersFieldsAssigned) {
                newSettings.study.teamMembersFields = accountSettings.study.teamMembersFields
                newSettings.study.teamMembersFieldsAssigned = true
            }
            if (!newSettings.study.sessionFieldsAssigned) {
                newSettings.study.sessionFields = accountSettings.study.sessionFields
                newSettings.study.sessionFieldsAssigned = true
            }

            const promiseArray: Promise<any>[] = []

            if (!settings.cc.defaultApprovalLevelsAssigned) {
                promiseArray.push(
                    CopyDefaultCcApprovalLevels(project.accountId, project.id, accountSettings.project.defaultGroupsAssigned).then(() => {
                        newSettings.cc.defaultApprovalLevelsAssigned = true
                    }),
                )
            }

            // CC responses
            if (!settings.cc.defaultResponsesAssigned) {
                promiseArray.push(
                    CopyDefaultCcResponses(
                        project.accountId,
                        project.id,
                        accountSettings.cc.defaultResponsesAssigned,
                    ).then(() => {
                        newSettings.cc.defaultResponsesAssigned = true
                    }),
                )
            }

            // CC review settings
            if (!settings.cc.defaultReviewItemTypesAssigned) {
                promiseArray.push(
                    CopyDefaultCcReviewReviewTypes(
                        project.accountId,
                        project.id,
                        accountSettings.cc.defaultReviewItemTypesAssigned,
                    ).then(() => {
                        newSettings.cc.defaultReviewItemTypesAssigned = true
                    }),
                )
            }

            // CC requirements settings
            if (!settings.cc.defaultRequirementsPriorityAssigned) {
                promiseArray.push(
                    CopyDefaultCcRequirementPriorities(
                        project.accountId,
                        project.id,
                        accountSettings.cc.defaultRequirementsPriorityAssigned,
                    ).then(() => {
                        newSettings.cc.defaultRequirementsPriorityAssigned = true
                    }),
                )
            }
            if (!settings.cc.defaultRequirementsReviewMethodAssigned) {
                promiseArray.push(
                    CopyDefaultCcRequirementReviewMethods(
                        project.accountId,
                        project.id,
                        accountSettings.cc.defaultRequirementsReviewMethodAssigned,
                    ).then(() => {
                        newSettings.cc.defaultRequirementsReviewMethodAssigned = true
                    }),
                )
            }
            if (!settings.cc.defaultRequirementsSmartComplianceAssigned) {
                promiseArray.push(
                    CopyDefaultCcRequirementSmartCompliances(
                        project.accountId,
                        project.id,
                        accountSettings.cc.defaultRequirementsSmartComplianceAssigned,
                    ).then(() => {
                        newSettings.cc.defaultRequirementsSmartComplianceAssigned = true
                    }),
                )
            }
            if (!settings.cc.defaultRequirementsStatusAssigned) {
                promiseArray.push(
                    CopyDefaultCcRequirementStatuses(
                        project.accountId,
                        project.id,
                        accountSettings.cc.defaultRequirementsStatusAssigned,
                    ).then(() => {
                        newSettings.cc.defaultRequirementsStatusAssigned = true
                    }),
                )
            }
            if (!settings.cc.defaultRequirementsTypeAssigned) {
                promiseArray.push(
                    CopyDefaultCcRequirementTypes(
                        project.accountId,
                        project.id,
                        accountSettings.cc.defaultRequirementsTypeAssigned,
                    ).then(() => {
                        newSettings.cc.defaultRequirementsTypeAssigned = true
                    }),
                )
            }

            return Promise.all(promiseArray).then(() => (
                SaveProjectSettings(project.id, newSettings)
                .then(() => {
                    if (dispatch) dispatch(setProjectProjectSettings(newSettings))
                })
            ))
        })
    ))
)
export default ImportDefaultProjectSettings
